import api from './client';
import type { TrackerPwa } from './tracker-types';

export const getTrackerPwas = () => api.get<TrackerPwa[]>('/admin/tracker/pwas');
export const getTrackerPwa = (id: string) => api.get<TrackerPwa>(`/admin/tracker/pwas/${id}`);
export const createTrackerPwa = (data: Partial<TrackerPwa> & { name: string }) =>
  api.post<TrackerPwa>('/admin/tracker/pwas', data);
export const updateTrackerPwa = (id: string, data: Partial<TrackerPwa>) =>
  api.put<TrackerPwa>(`/admin/tracker/pwas/${id}`, data);
export const deleteTrackerPwa = (id: string) =>
  api.delete<{ message: string }>(`/admin/tracker/pwas/${id}`);
